import { render, staticRenderFns } from "./SubMenuItem.html?vue&type=template&id=276dae2d&scoped=true&"
import script from "./SubMenuItem.js?vue&type=script&lang=js&"
export * from "./SubMenuItem.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=276dae2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276dae2d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VMenu})
